import { Link } from 'react-router-dom';
import { CASE_STUDIES } from '../../data/caseStudies';
import ImageSlot from '../ui/ImageSlot';

/**
 * Case Studies grid — homepage section. Each card is a region/program
 * Lincoln has been deployed to. Image-slot cover + region tag + metric.
 */
export default function CaseStudiesGrid() {
  return (
    <section className="lc-section" style={{ background: '#fff' }}>
      <div className="lc-container">
        <div className="text-center" style={{ marginBottom: 56 }}>
          <span className="lc-eyebrow">Case studies</span>
          <h2 className="mt-3.5">From a Maltese classroom to the World Economic Forum.</h2>
          <p className="mx-auto mt-3.5" style={{ color: 'var(--muted)', fontSize: 18, maxWidth: 580 }}>
            Lincoln is deployed by ministries, NGOs, schools, and the world&apos;s largest organizations.
          </p>
        </div>

        <div className="grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}>
          {CASE_STUDIES.map((cs) => (
            <article key={cs.slug} className="lc-card overflow-hidden flex flex-col">
              <div className="relative overflow-hidden"
                style={{ height: 200, background: `linear-gradient(135deg, ${cs.color} 0%, ${cs.color}cc 100%)` }}>
                <ImageSlot
                  id={`cs-cover-${cs.img}`}
                  style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}
                  shape="rect"
                  src={cs.photo}
                  placeholder={`Drop a ${cs.region} photo`}
                />
                <div className="absolute inset-0 pointer-events-none"
                  style={{ background: 'linear-gradient(180deg, rgba(0,0,0,0) 50%, rgba(0,0,0,0.5) 100%)' }} />
                <div className="absolute font-bold tracking-wider pointer-events-none"
                  style={{ top: 14, left: 14, background: 'rgba(255,255,255,0.95)', color: cs.color, padding: '5px 10px', borderRadius: 999, fontSize: 11 }}>
                  {cs.tag}
                </div>
                <div className="absolute font-bold font-serif pointer-events-none"
                  style={{ bottom: 14, right: 14, background: 'rgba(11,31,56,0.92)', color: 'var(--yellow)', padding: '5px 12px', borderRadius: 6, fontSize: 13 }}>
                  {cs.metric}
                </div>
              </div>
              <div className="flex flex-col flex-1" style={{ padding: 24 }}>
                <div className="font-semibold uppercase tracking-wider inline-flex items-center gap-1.5" style={{ fontSize: 11, color: 'var(--muted)' }}>
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                  {cs.region}
                </div>
                <h3 className="mt-2.5" style={{ fontSize: 22 }}>{cs.title}</h3>
                <p className="mt-3 leading-relaxed" style={{ color: 'var(--muted)', fontSize: 14 }}>{cs.desc}</p>
                <Link
                  to={`/case-studies/${cs.slug === 'malta' ? 'malta' : 'malta'}`}
                  className="lc-link self-start mt-4"
                >
                  Read case study →
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/case-studies/malta" className="lc-btn ghost">View all case studies →</Link>
        </div>
      </div>
    </section>
  );
}
